<ng-template transloco>
  <router-outlet></router-outlet>
</ng-template>
